<template>
	<v-item
		v-slot:default="{ active, toggle }"
		class="mt-1 mr-1"
	>
		<div class="selectable-item pa-2 d-inline-block" @click="toggle">
			<span>{{id}}</span>
		</div>
	</v-item>
</template>

<script>
	export default {
		props: {
			id: String
		}
	};
</script>

<style scoped>
	.selectable-item {
		border: 1px solid #c7c7c7;
		cursor: pointer;
	}
	.active-item {
		border: 1px solid green;
		background-color: #e9ffe9;
		pointer-events: none;
	}
</style>